import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthGuard from '~components/AuthGuard';
import DeviceGuard from '~components/DeviceGuard';
import ErrorBoundary from '~components/ErrorBoundary';
import QueryProvider from '~components/QueryProvider';
import UIProvider from '~components/UIProvider';
import Edit from './pages/Edit';
import Home from './pages/Home';
import LoginPage from './pages/Login';

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <DeviceGuard>
          <UIProvider>
            <QueryProvider>
              <Routes>
                {/* 모든 라우트는 AuthGuard 아래에서 token/path 기준으로 접근 제어 */}
                <Route element={<AuthGuard />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/edit/:id" element={<Edit />} />
                  <Route path="/edit" element={<Edit />} />
                  <Route path="/login" element={<LoginPage />} />
                </Route>
              </Routes>
            </QueryProvider>
          </UIProvider>
        </DeviceGuard>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
